import React from 'react';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import { SHORTCUT_HELP } from './lib/shortcuts';
import { FONT, RADIUS } from './lib/brand';

export function ShortcutsHelp({ open, onClose }: { open: boolean; onClose: () => void }) {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs" aria-labelledby="keys-title" data-testid="shortcuts-help">
      <DialogTitle id="keys-title" sx={{ fontFamily: FONT.heading, fontSize: 16, fontWeight: 700 }}>Keyboard shortcuts</DialogTitle>
      <DialogContent dividers>
        <Box component="dl" sx={{ m: 0, display: 'grid', gridTemplateColumns: 'auto 1fr', columnGap: 2, rowGap: 1 }}>
          {SHORTCUT_HELP.map((s) => (
            <React.Fragment key={s.keys}>
              <Box component="dt"><Box component="kbd" sx={{ fontFamily: FONT.mono, fontSize: 12, px: 0.8, py: 0.2, border: '1px solid', borderColor: 'divider', borderRadius: RADIUS.md, bgcolor: 'action.hover', whiteSpace: 'nowrap' }}>{s.keys}</Box></Box>
              <Typography component="dd" sx={{ m: 0, fontSize: 13 }}>{s.does}</Typography>
            </React.Fragment>
          ))}
        </Box>
        <Typography variant="caption" color="text.secondary" component="div" sx={{ mt: 1.5 }}>Shortcuts are ignored while you are typing in a field.</Typography>
      </DialogContent>
      <DialogActions><Button onClick={onClose} autoFocus>Close</Button></DialogActions>
    </Dialog>
  );
}
